import React from "react";

import { strings } from "@perceptron/constants";
import { UI_COLORS } from "@perceptron/constants/colors";
import { transformPlayerSrc } from "@perceptron/core";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@perceptron/ui/components/dialog";
import { getContentTypeFromExtension } from "@perceptron/utils/mime";
import { MediaPlayer, MediaProvider } from "@vidstack/react";

import { MediaData } from "@demo/types/base";
import "@vidstack/react/player/styles/base.css";

interface VideoDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  media: MediaData;
}

export function VideoDialog({ isOpen, onOpenChange, media }: VideoDialogProps) {
  const videoSrc = media.url || "";

  if (!videoSrc) {
    console.error("Video URL is missing for media:", media);
  }

  const playerSrc = {
    src: videoSrc,
    type: getContentTypeFromExtension(media.extension),
  };

  const renderVideoContent = () => {
    if (!videoSrc) {
      return <div className="text-center text-gray-500">{strings.videoDialog.invalidVideoData}</div>;
    }

    return (
      <div className="flex h-full w-full items-center justify-center">
        <MediaPlayer controls muted preload="metadata" src={transformPlayerSrc(playerSrc)}>
          <MediaProvider />
        </MediaPlayer>
      </div>
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[90vw] border-none bg-transparent p-0">
        <DialogHeader className="sr-only">
          <DialogTitle>{strings.videoDialog.videoPreview}</DialogTitle>
        </DialogHeader>
        <div
          className="relative h-[90vh] w-full rounded-2xl p-2"
          style={{ backgroundColor: UI_COLORS.BACKGROUND_DARK }}
        >
          {renderVideoContent()}
        </div>
      </DialogContent>
    </Dialog>
  );
}
